import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import "../styles/contact-us.css";

/* ---------- Content: edit these ---------- */
// Or use your own constant: import ROUTES ... and ROUTES.WEB3FORMS_URL
const WEB3FORMS_URL = "https://api.web3forms.com/submit";

// const MAP_SRC =
//   "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1903.6939786137586!2d72.94299979534378!3d19.19490216415948!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b925823acd43%3A0xcb6fa0c705c7d7f3!2sGlobal%20Tech9%20LLC!5e0!3m2!1sen!2sin!4v1791023557995!5m2!1sen!2sin";

const MAP_SRC =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3443.32701283137!2d-97.75741282474758!3d30.341654904428324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8644cae2f96fffff%3A0x893fa7795b7d5f91!2sGenesis%20Business%20Solutions%20LLC%2C%205900%20Balcones%20Dr%20Suit%20100%2C%20Austin%2C%20TX%2078731%2C%20USA!5e0!3m2!1sen!2sin!4v1792606728918!5m2!1sen!2sin";

const offices = [
  // {
  //   name: "Global Tech9 LLC",
  //   lines: [
  //     "Office no. 623, Centura Square IT Park,",
  //     "Thane, Maharashtra 400604, India",
  //   ],
  //   query:
  //     "Office no. 623, Centura Square IT Park, Thane, Maharashtra 400604, India",
  // },
  {
    name: "Global Tech9 LLC",
    lines: ["5900 Balcones Drive STE 100,", "Austin, TX 78731, USA"],
    query: "5900 Balcones Drive STE 100, Austin, TX 78731, USA",
  },
];

const socials = [
  { key: "linkedin", name: "LinkedIn", text: "Connect with us", href: "#" },
  { key: "x", name: "X", text: "Follow our updates", href: "#" },
  {
    key: "facebook",
    name: "Facebook",
    text: "Join the conversation",
    href: "#",
  },
  { key: "instagram", name: "Instagram", text: "See what we share", href: "#" },
];

/* ---------- Icons ---------- */
const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true",
};
const Icon = {
  crumb: (
    <svg viewBox="0 0 24 24" {...stroke} strokeWidth="2.2">
      <path d="M9 6l6 6-6 6" />
    </svg>
  ),
  arrow: (
    <svg viewBox="0 0 24 24" {...stroke} strokeWidth="2">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  ),
  phone: (
    <svg viewBox="0 0 24 24" {...stroke} strokeWidth="1.8">
      <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" />
    </svg>
  ),
  mail: (
    <svg viewBox="0 0 24 24" {...stroke} strokeWidth="1.8">
      <path d="M3 6h18v12H3zM3 7l9 6 9-6" />
    </svg>
  ),
  clock: (
    <svg viewBox="0 0 24 24" {...stroke} strokeWidth="1.8">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  ),
  pin: (
    <svg viewBox="0 0 24 24" {...stroke} strokeWidth="1.8">
      <path d="M12 21s7-6.2 7-11.5a7 7 0 1 0-14 0C5 14.8 12 21 12 21z" />
      <circle cx="12" cy="9.5" r="2.5" />
    </svg>
  ),
  linkedin: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9.5h4V21H3zm6.5 0h3.8v1.6h.1c.5-1 1.8-1.9 3.7-1.9 4 0 4.7 2.6 4.7 6V21h-4v-5.1c0-1.2 0-2.8-1.7-2.8s-2 1.3-2 2.7V21h-4z" />
    </svg>
  ),
  x: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  ),
  facebook: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M13.5 22v-8.2h2.8l.5-3.4h-3.3V8.3c0-1 .4-1.8 1.9-1.8h1.5V3.4c-.3 0-1.3-.1-2.4-.1-2.5 0-4.2 1.5-4.2 4.3v2.8H7.5v3.4h2.8V22z" />
    </svg>
  ),
  instagram: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <circle
        cx="12"
        cy="12"
        r="4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <circle cx="17.3" cy="6.7" r="1.2" />
    </svg>
  ),
};

const mapsLink = (query) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

/* ---------- Validation ---------- */
const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
function validate(form) {
  const v = (name) => (form.elements[name]?.value || "").trim();
  const errors = {};
  if (v("name").length < 2) errors.name = "Please enter your name.";
  if (!emailRe.test(v("email")))
    errors.email = "Please enter a valid email address.";
  if (v("subject").length < 3) errors.subject = "Please add a short subject.";
  if (v("message").length < 10)
    errors.message = "Please write a message (at least 10 characters).";
  return errors;
}

function Field({ id, label, error, full, children }) {
  return (
    <div
      className={`gt9-field${full ? " gt9-field--full" : ""}${error ? " has-error" : ""}`}
    >
      <label htmlFor={id}>
        {label} <span>*</span>
      </label>
      {children}
      {error && (
        <p className="gt9-error" id={`err-${id}`}>
          {error}
        </p>
      )}
    </div>
  );
}

export default function Contact() {
  const [captchaToken, setCaptchaToken] = useState(null);
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
  const [notice, setNotice] = useState(null); // { type: "success" | "error", text }
  const [errors, setErrors] = useState({});

  const captchaRef = useRef(null);
  const noticeRef = useRef(null);

  // clear a field's error (and the message) as soon as the visitor edits it
  const onInput = (event) => {
    const { name } = event.target;
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: undefined }));
    if (notice) setNotice(null);
  };

  const resetCaptcha = () => {
    captchaRef.current?.resetCaptcha(); // hCaptcha tokens are single-use
    setCaptchaToken(null);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    if (disableSubmitBtn) return;
    setNotice(null);

    const form = event.target;
    const found = validate(form);
    setErrors(found);
    const firstBad = Object.keys(found)[0];
    if (firstBad) {
      form.elements[firstBad]?.focus();
      return;
    }

    if (!captchaToken) {
      setNotice({ type: "error", text: "Please complete the captcha first." });
      return;
    }
    setDisableSubmitBtn(true);

    const formData = new FormData(form);
    formData.append("h-captcha-response", captchaToken);
    formData.append("access_key", process.env.REACT_APP_WEB3FORMS_CONTACT_KEY);

    try {
      const response = await fetch(WEB3FORMS_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(Object.fromEntries(formData)),
      });

      const data = await response.json();

      if (!data["success"]) {
        throw new Error(
          data["message"] || "Oops! Your message could not be sent.",
        );
      }

      setNotice({
        type: "success",
        text: "Thank you! Your message has been sent.",
      });
      form.reset();
    } catch (e) {
      setNotice({
        type: "error",
        text: e?.message || "Oops! Your message could not be sent.",
      });
    } finally {
      resetCaptcha();
      setDisableSubmitBtn(false);
      setTimeout(
        () =>
          noticeRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          }),
        50,
      );
    }
  };

  return (
    <main className="gt9-ct">
      {/* Hero */}
      <section className="gt9-ct__hero">
        <div className="gt9-container">
          <ol className="gt9-crumbs" aria-label="Breadcrumb">
            <li>
              <Link to="/">Home</Link>
              {Icon.crumb}
            </li>
            <li aria-current="page">Contact us</li>
          </ol>
          <span className="gt9-eyebrow">Contact us</span>
          <h1 className="gt9-ct__title">
            Let's talk about your <span className="hl">technology</span>
          </h1>
          <p className="gt9-ct__lead">
            Questions, a project or a support request? Send us a message and our
            IT team will get back to you.
          </p>
        </div>
      </section>

      <div className="gt9-ct__body">
        <div className="gt9-container">
          {/* Quick contact */}
          <div className="gt9-quick">
            <div className="gt9-quick__item">
              <i>{Icon.phone}</i>
              <div>
                <small>Call us</small>
                {/* <a href="tel:+917977353388">+91 79773 53388</a> */}
                <p>Speak to our IT team directly.</p>
              </div>
            </div>
            <div className="gt9-quick__item">
              <i>{Icon.mail}</i>
              <div>
                <small>Email us</small>
                <a href="mailto:contact@globaltech9.com">
                  contact@globaltech9.com
                </a>
                <p>
                  Support:{" "}
                  <a
                    href="mailto:support@globaltech9.com"
                    style={{
                      display: "inline",
                      font: "inherit",
                      fontWeight: 600,
                    }}
                  >
                    support@globaltech9.com
                  </a>
                </p>
              </div>
            </div>
            <div className="gt9-quick__item">
              <i>{Icon.clock}</i>
              <div>
                <small>Working hours</small>
                <span className="v">Mon to Sat</span>
                <p>8:00 AM – 6:00 PM</p>
              </div>
            </div>
          </div>

          {/* Form + offices */}
          <div className="gt9-ct__grid">
            <section
              className="gt9-card gt9-formcard"
              aria-labelledby="gt9-form-title"
            >
              <div className="gt9-head">
                <span className="gt9-eyebrow gt9-eyebrow--dark">
                  Send a message
                </span>
                <h2 id="gt9-form-title">How can we help you?</h2>
                <p>
                  Fill in the form and we will reply as soon as we can during
                  working hours.
                </p>
              </div>

              <form onSubmit={onSubmit} onInput={onInput} noValidate>
                <div className="gt9-form__grid">
                  <Field id="name" label="Your name" error={errors.name}>
                    <input
                      id="name"
                      name="name"
                      type="text"
                      autoComplete="name"
                      placeholder="Your full name"
                      aria-invalid={errors.name ? "true" : undefined}
                    />
                  </Field>
                  <Field id="email" label="Email address" error={errors.email}>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      placeholder="you@example.com"
                      aria-invalid={errors.email ? "true" : undefined}
                    />
                  </Field>
                  <Field
                    id="subject"
                    label="Subject"
                    error={errors.subject}
                    full
                  >
                    <input
                      id="subject"
                      name="subject"
                      type="text"
                      placeholder="What is this about?"
                      aria-invalid={errors.subject ? "true" : undefined}
                    />
                  </Field>
                  <Field
                    id="message"
                    label="Message"
                    error={errors.message}
                    full
                  >
                    <textarea
                      id="message"
                      name="message"
                      placeholder="Tell us a little about what you need"
                      aria-invalid={errors.message ? "true" : undefined}
                    />
                  </Field>
                </div>

                <div className="gt9-captcha">
                  <HCaptcha
                    ref={captchaRef}
                    sitekey={process.env.REACT_APP_HCAPTCHA_KEY}
                    reCaptchaCompat={false}
                    onVerify={(token) => {
                      setCaptchaToken(token);
                      setNotice(null);
                    }}
                    onExpire={() => setCaptchaToken(null)}
                    onError={() => setCaptchaToken(null)}
                  />
                </div>

                {notice && (
                  <div
                    ref={noticeRef}
                    className={`gt9-alert gt9-alert--${notice.type}`}
                    role={notice.type === "error" ? "alert" : "status"}
                  >
                    {notice.text}
                  </div>
                )}

                <div className="gt9-form__foot">
                  <p>We only use your details to reply to your message.</p>
                  <button
                    type="submit"
                    className="gt9-btn"
                    disabled={disableSubmitBtn}
                  >
                    {disableSubmitBtn ? (
                      <>
                        <span className="gt9-spin" aria-hidden="true" />{" "}
                        Sending…
                      </>
                    ) : (
                      <>Send message {Icon.arrow}</>
                    )}
                  </button>
                </div>
              </form>
            </section>

            <div className="gt9-offices">
              <div className="gt9-head">
                <span className="gt9-eyebrow gt9-eyebrow--dark">
                  Our office
                </span>
                <h2>Visit us in person</h2>
                <p>One office, one team. Drop by or get directions.</p>
              </div>
              {offices.map((o) => (
                <article className="gt9-card gt9-office" key={o.name}>
                  <div className="gt9-office__top">
                    <span className="gt9-office__pin">{Icon.pin}</span>
                  </div>
                  <address>
                    <b>{o.name}</b>
                    {o.lines.map((l, i) => (
                      <React.Fragment key={l}>
                        {i > 0 && <br />}
                        {l}
                      </React.Fragment>
                    ))}
                  </address>
                  <a
                    className="gt9-link"
                    href={mapsLink(o.query)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Get directions {Icon.arrow}
                  </a>
                </article>
              ))}
            </div>
          </div>

          {/* Map */}
          <section
            className="gt9-mapwrap"
            aria-labelledby="gt9-map-title"
            id="google-location"
          >
            <div className="gt9-head">
              <span className="gt9-eyebrow gt9-eyebrow--dark">Find us</span>
              <h2 id="gt9-map-title">Our location in Texas</h2>
              <p>Balcones Dr Suit 100, Austin, Texas.</p>
            </div>
            <div className="gt9-map">
              <iframe
                title="Our location"
                src={MAP_SRC}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
              <div className="gt9-map__card">
                <b>Global Tech9 LLC</b>
                <p>{offices[0].lines.join(" ")}</p>
                <a
                  className="gt9-link"
                  href={mapsLink(offices[0].query)}
                  target="_blank"
                  rel="noreferrer"
                >
                  Open in Google Maps {Icon.arrow}
                </a>
              </div>
            </div>
          </section>

          {/* Social */}
          <section className="gt9-soc" aria-labelledby="gt9-soc-title">
            <div>
              <span className="gt9-eyebrow">Social media</span>
              <h2 id="gt9-soc-title">
                Prefer to reach us <span className="hl">online?</span>
              </h2>
              <p>
                Follow Global Tech9 LLC and message us on your favourite platform.
                We are happy to chat.
              </p>
            </div>
            <div className="gt9-soc__grid">
              {socials.map((s) => (
                <a
                  className="gt9-soc__tile"
                  key={s.key}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={`${s.name} (opens in a new tab)`}
                >
                  <i>{Icon[s.key]}</i>
                  <div>
                    <b>{s.name}</b>
                    <span>{s.text}</span>
                  </div>
                </a>
              ))}
            </div>
          </section>
        </div>
      </div>
    </main>
  );
}
